import React from "react"
import { Button, Box, FormControl, useTheme, makeStyles, TextField } from "@material-ui/core"
import "./SortByRelevance.css"

const useStyles = makeStyles((theme) => ({
	margin: {
		margin: theme.spacing(1),
	},
}))

const SortByRelevance = ({ onClickHandler, isDisabled }) => {
	const theme = useTheme()
	const classes = useStyles()
	return (
		<>
			<Button
				variant="outlined"
				size="small"
				className={classes.margin}
				onClick={onClickHandler}
				style={{
					color: !isDisabled ? theme.palette.primary.dark : "",
					border: !isDisabled ? `1px solid ${theme.palette.primary.dark}` : "",
					textTransform: 'initial'
				}}
				disabled={isDisabled}
			>
				Sort by Relevance
			</Button>
		</>
	)
}

export default SortByRelevance
